<template>
    <div class="loader-bar">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
        <div class="bar4"></div>
        <div class="bar5"></div>
    </div>
</template>
<script>
    export default {
        name: 'LoaderBar'
    }
</script>
<style scoped>
    .loader-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        
        background-color: rgba(128, 128, 128, 0.5);
    }

    .loader-bar > div {
        height: 50px;
        width: 10px;
        
        background-color: #ffffff;
        display: inline-block;

        -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
        animation: sk-stretchdelay 1.2s infinite ease-in-out;
    }

    .loader-bar .bar2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
    }

    .loader-bar .bar3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }

    .loader-bar .bar4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
    }

    .loader-bar .bar5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
    }

    @-webkit-keyframes sk-stretchdelay {
        0%, 40%, 100% {
            -webkit-transform: scaleY(0.4)
        }
        20% {
            -webkit-transform: scaleY(1.0)
        }
    }

    @keyframes sk-stretchdelay {
        0%, 40%, 100% {
            transform: scaleY(0.4);
            -webkit-transform: scaleY(0.4);
        }
        20% {
            transform: scaleY(1.0);
            -webkit-transform: scaleY(1.0);
        }
    }
</style>
